import React, { useState } from 'react';
import Navbar, { closeNavbar } from '../components/Navbar';
import WidgetBox from '../components/WidgetBox';
import DataBlock from '../components/overview_widgets/DataBlock';
import Map from "../components/overview_widgets/Map";
import PageContainer from '../components/containers/PageContainer';
import ContentBlock from '../components/containers/ContentBlock';
import CordDisplay from '../components/overview_widgets/CordDisplay';
import OverviewEditButtons from '../components/OverviewEditButtons';
import WinchData from '../components/overview_widgets/WinchData';
import { getByPath } from '../features/Sensors/SensorUtils';
import { useAppSelector } from '../hooks';
import { c_time, c_MeteoDataFields, c_AquaFlowFields, c_WinchDataFields} from "../config/uiconfig"

//declare types for the temp data fields
type fields = {
  label: string;
  path: string;
};

type tableFields = {
    name: string;
    tension: string;
    speed: string;
    payout: string;
};




export default function Overview({ kiosk }: {
  kiosk: boolean;
}) {
  //create usestate to enable edit
  const [editLayout, setEditLayout] = useState(true);
  if (kiosk) {
    setTimeout(() => {
      closeNavbar();
    }, 100);

  }



  //prev in front checks for previous value to change it to the value it wasn't before
  const handleClick = () => {
    setEditLayout(prevEditLayout => !prevEditLayout);
    const editbutton = document.getElementById("editButton");
    const layoutbuttons = document.getElementById("layoutbuttons")
    if (editbutton?.innerHTML === "Edit Layout") {
      editbutton.innerHTML = "Cancel"
      layoutbuttons?.classList.remove("hidden")
    } else if (editbutton?.innerHTML === "Cancel") {
      editbutton.innerHTML = "Edit Layout"
      layoutbuttons?.classList.add("hidden")
    }

  };
  
  function formatNMEATime(
    value?: string | number
): string | null {
    if (value == null) return null;

    const str = String(value);
    const [timePart, fraction = ""] = str.split(".");

    const padded = timePart.padStart(6, "0");
    if (!/^\d{6}$/.test(padded)) return null;

    const hours = parseInt(padded.slice(0, 2), 10);
    const minutes = parseInt(padded.slice(2, 4), 10);
    const seconds = parseInt(padded.slice(4, 6), 10);

    if (hours > 23 || minutes > 59 || seconds > 59) {
        return null;
    }

    const ms = fraction ? `.${fraction}` : "";

    return `${padded.slice(0,2)}:${padded.slice(2,4)}:${padded.slice(4,6)}${ms} UTC`;
}


  const layout = [
    { i: "navdata", x: 0, y: 0, w: 5, h: 9, static: editLayout },
    { i: "meteodata", x: 5, y: 0, w: 4, h: 5, static: editLayout },
    { i: "map", x: 9, y: 0, w: 3, h: 9, static: editLayout },
    { i: "flowdata", x: 5, y: 5.5, w: 4, h: 5, static: editLayout },
    { i: "winchdata", x: 0, y: 14.5, w: 12, h: 8, static: editLayout }
  ];

  const measurements = useAppSelector(state => state.Measurements.measurements);
  const content: JSX.Element[] =
    [
      <div key="navdata">
        <ContentBlock title={'Nav Data'} overviewTime={formatNMEATime(getByPath(c_time, measurements)?.value)} >
          <CordDisplay />
        </ContentBlock>
      </div>,
      <div key="meteodata">
        <ContentBlock title='Meteo Data'>
          <DataBlock DataFields={c_MeteoDataFields} />
        </ContentBlock>
      </div>,
      <div key="flowdata">
        <ContentBlock title='pCO2'>
          <DataBlock DataFields={c_AquaFlowFields} />
        </ContentBlock>
      </div>,
      <div key="map">
        <ContentBlock title='Map'>
          <Map />
        </ContentBlock>
      </div>,
      <div key="winchdata">
        <ContentBlock title='Winch Data'>
          <WinchData DataFields={c_WinchDataFields} />
        </ContentBlock>
      </div>
    ]

  return (
    <>
      <Navbar />
      <PageContainer title='Overview' buttons={<OverviewEditButtons />}>
        <WidgetBox page_layout={layout} content={content}></WidgetBox>
      </PageContainer>
    </>
  );
}